/* global rp$, document, window */
import get from 'lodash/get';
import paypalSmartButtons from '../../../js/components/paypal-smart-buttons';

var THE_SCRIPT = function() {
	const cacheConfig = require('public/js/lib/cache-config');
	const $onReady = require("public/js/lib/on-ready");
	const {
		getItem,
		setItem,
		STORAGE_KEYS,
	} = require('public/js/lib/local-storage');
	const {
		buildPdpCalloutCityPostalLabel,
		getInventoryMessage,
		getInventoryMessageCustomerId,
		getInventoryMessageWarehouseId,
		getPickupMessage,
		getShippingEstimateMessage,
		getShippingMessage,
		getShippingMessageTitle,
		handleZipChangeEvent,
	} = require('public/js/lib/product-message-utils');
	const { LOCATION_CHANGED_EVENT } = require('public/js/lib/location-events');
	const { resetPurchaseModalStyles } = require('public/js/lib/sticky-div');

	(function ProductInventoryMessagingModule() {
		/**
		 * DOM for the PDP ZIP callout is rendered in element-purchase.html; syncs labels,
		 * data attributes, and visibility between the two links (destination vs enter-ZIP).
		 */
		function updatePdpZipCalloutUi(zipCodeRaw, locationLabelRaw = '') {
			const zipCode = String(zipCodeRaw ?? '').trim();
			const locationLabel = String(locationLabelRaw ?? '').trim();
			const $callouts = rp$('.pdp-zip-callout');
			if (!$callouts.length) {
				return;
			}

			$callouts.each(function updateOneZipCallout() {
				const $zipCallout = rp$(this);
				const shipsToLabel = String($zipCallout.attr('data-ships-to-label') ?? '');
				const addZipLabel = String($zipCallout.attr('data-add-zip-label') ?? '');

				$zipCallout.attr('data-current-zip', zipCode);
				$zipCallout.attr('data-current-location-label', locationLabel);
				$zipCallout.find('.pdp-zip-callout-ships-to').first().text(shipsToLabel);

				const $destination = $zipCallout.find('.pdp-zip-callout-destination').first();
				const $enter = $zipCallout.find('.pdp-zip-callout-enter').first();

				if (zipCode === '') {
					$destination.attr('hidden', 'hidden');
					$enter.text(addZipLabel).removeAttr('hidden');
					return;
				}

				const calloutValue = locationLabel !== '' ? locationLabel : zipCode;
				$destination.text(calloutValue).removeAttr('hidden');
				$enter.attr('hidden', 'hidden');
			});
		}

		function HandleInventoryMessageResponse({
			$inventoryMessageContentEle,
			$shippingMessageContentEle,
			$shippingEstimateMessageContentEle,
			$shippingEstimateMessageHelpTextEle,
			$shippingEstimatePostalCodeEle,
			$shippingMessageSectionTitleEle,
			$shippingMessageSectionEle,
			$pickupMessageContentEle,
			$pickupMessageSectionEle,
			$addToCartBtn,
			$inventoryWrap,
            $shippingIcon,
            $inventoryStockIcon
		}) {
			return function(evt, response) {
				// Unset `Add To Cart` button's data attribute (data-inventory-message)
				// when no `inventoryMessage`
				const responseInventoryMessage = getInventoryMessage(response);
				const responseShippingMessage = getShippingMessage(response);
				const responseShippingMessageTitle = getShippingMessageTitle(response);
				const responseShippingEstimateMessage = getShippingEstimateMessage(response);
				const responseInventoryMessageCustomerId = getInventoryMessageCustomerId(response);
				const responseInventoryMessageWarehouseId = getInventoryMessageWarehouseId(response);

				const responsePickupMessage = getPickupMessage(response);
				const responseInventoryType = response.inventoryMessageType ? response.inventoryMessageType : '';
				$inventoryMessageContentEle.html(responseInventoryMessage);
				$shippingMessageContentEle.html(responseShippingMessage);
				$shippingMessageSectionTitleEle.html(responseShippingMessageTitle);
				$shippingEstimateMessageContentEle.html(responseShippingEstimateMessage);
				$pickupMessageContentEle.html(responsePickupMessage);

				$addToCartBtn.attr(
					"data-inventory-message",
					responseInventoryMessage
				);
				$addToCartBtn.attr(
					"data-shipping-message",
					responseShippingMessage
				);

				$inventoryWrap.removeClass('inventory-out-of-stock');
				if (responseInventoryType === 'OutOfStockMessagingOnly') {
					$inventoryWrap.addClass('inventory-out-of-stock');
				}

				$inventoryWrap.attr("hidden", !$inventoryWrap.parent().hasClass('fitment-redesign') && responseInventoryMessage === '');
				$shippingMessageContentEle.attr("hidden", responseShippingMessage === '');
				$shippingMessageSectionEle.attr("hidden", responseShippingMessage === '' && responseShippingEstimateMessage === '');
				$shippingEstimateMessageContentEle.attr("hidden", responseShippingEstimateMessage === '');
				$pickupMessageSectionEle.attr("hidden", responsePickupMessage === '');
				$shippingEstimateMessageHelpTextEle.attr("hidden", responseShippingEstimateMessage === '');

                $shippingIcon.attr("hidden", responseShippingMessage === '');
                $inventoryStockIcon.attr("hidden", responseInventoryMessage === '');

				if (responseShippingEstimateMessage !== '') {
					$shippingEstimateMessageContentEle.attr(
						"data-inventory-warehouse-id",
						responseInventoryMessageWarehouseId
					);

					$shippingEstimateMessageContentEle.attr(
						"data-inventory-warehouse-customer-id",
						responseInventoryMessageCustomerId
					);
				}

				handleZipChangeEvent();

				// Update the tracking value to accurately depict what's on the page
				if (responseInventoryType && window.tracking && (typeof window.tracking.dimensions === 'object')) {
					window.tracking.dimensions.stockLevelMessaging = responseInventoryType;
				}
			};
		}

		function HandleDealerSelect(evt) {
			evt.preventDefault();
			const dealerHash = rp$(this).data("fulfillment-hash");
			if(!dealerHash ) {
				return;
			}

			window.rp_app?.invalidateSupplierCache?.();

			$ajax({
				method: "POST",
				dataType: "json",
				url: "/ajax/dealers",
				data: {
					dealerHash
				},
				success: (response, status /*, xhr*/) => {
					if (status === "success") {
						rp_app.location.reload();
					}
				}
			});
		}

		function HandleViewMoreDealers(evt) {
			evt.preventDefault();

			window.rp_app.request({
				type: 'GET',
				url: '/ajax/cart',
				dataType: 'json',
				contentType: 'application/json',
				success: HandleViewMoreDealersRedirect,
			});
		}

		function HandleViewMoreDealersRedirect(cart) {
			const cartHasItems = !!get(cart, 'itemsCount');
			if (cartHasItems) {
				const $dealerSelectionWarningModal = rp$(".dealer-selection-warning-modal");
				if ($dealerSelectionWarningModal) {
					$dealerSelectionWarningModal.modal();
				}
			} else {
				ClearSelectedDealer();
			}
		}

		function ClearSelectedDealer() {
			window.rp_app?.invalidateSupplierCache?.();

			$ajax({
				method: "GET",
				dataType: "json",
				url: "/ajax/dealers/clear",
				success: (response, status /*, xhr*/) => {
					if (status === "success") {
						rp_app.location.reload();
					}
				}
			});
		}

		function loadMarketplaceViewOffersResources() {
			const $viewOffersLink = rp$(".marketplace-view-offers-box")
			$ajax({
				method: "GET",
				dataType: "json",
				url: "/ajax/product/select-dealer-resources",
				data: {
					catalog: rp$('.product-purchase-module').data('catalog') || '',
					sku: rp$('.product-purchase-module').data('sku-stripped') || ''
				},
				success: (response) => {
					if (response && response.marketplace_view_offers_html) {
						// Replace or append the marketplace view offers content
						if ($viewOffersLink) {
							$viewOffersLink.append(response.marketplace_view_offers_html);
						} 

						// Populate the postal code form field if available
						if (response.postal_code) {
							const $postalCodeInput = rp$('.change-location-input');
							if ($postalCodeInput.length > 0) {
								$postalCodeInput.val(response.postal_code);
							}
						}
						// Bind the modal button events directly here
						const $dealerSelectionWarningModal = rp$(".dealer-selection-warning-modal");
						if ($dealerSelectionWarningModal.length > 0) {
							const $cancelButton = rp$(".cancel-button", $dealerSelectionWarningModal);
							const $continueButton = rp$(".continue-button", $dealerSelectionWarningModal);
							
							$cancelButton.off("click").on("click", function(evt) {
								evt.preventDefault();
								$dealerSelectionWarningModal.modal('hide');
							});
							
							$continueButton.off("click").on("click", function(evt) {
								evt.preventDefault();
								
								// Execute the ClearSelectedDealer function
								if (typeof ClearSelectedDealer === 'function') {
									ClearSelectedDealer();
								}
								
								// Then hide the modal
								$dealerSelectionWarningModal.modal('hide');
							});
						}

						// Re-initialize the view offers link event handler
						const $newViewOffersLink = rp$(".purchase-box .view-offers-link");	
						if ($newViewOffersLink) {
							$newViewOffersLink.off("click").on("click", HandleViewMoreDealers);
						}
					}
					if(response.dealer_selection_warning_modal) {
						populateDealerSelectionWarningModal(response.dealer_selection_warning_modal);
					}
				},
				error: (e) => {
					console.log("error",e)
				}
			});
		}

		function populateDealerSelectionWarningModal(response) {
			const warningHeading = response.warning_heading;
			const warningSubheading = response.warning_subheading;
			const cancel = response.cancel;
			const continueButton = response.continue;
			rp$(".warning-heading", rp$(".dealer-selection-warning-modal")).html(warningHeading);
			rp$(".warning-subheading", rp$(".dealer-selection-warning-modal")).html(warningSubheading);
			rp$(".cancel-button", rp$(".dealer-selection-warning-modal")).html(cancel);
			rp$(".continue-button", rp$(".dealer-selection-warning-modal")).html(continueButton);
		}
		$onReady({
			rp$,
			window,
			label: "product_purchase",
			fn: function() {
				resetPurchaseModalStyles(false);
				const $inventoryMessageContentEle = rp$("#rp_inventory_message");
				const $shippingMessageContentEle = rp$("#rp_shipping_message");
				const $shippingEstimateMessageContentEle = rp$("#rp_shipping_estimate_message");
				const $shippingMessageSectionTitleEle = rp$(".shipping-message-title");
				const $shippingMessageSectionEle = rp$(".shipping-message-section");
				const $shippingEstimateMessageHelpTextEle = rp$(".shipping-estimate-message-helptext");
				const $shippingEstimatePostalCodeEle = rp$(".shipping-estimate-postal-code");
				const $pickupMessageContentEle = rp$("#rp_pickup_message");
				const $pickupMessageSectionEle = rp$(".pickup-message-section");
				const $addToCartBtn = rp$(".product-purchase button.add-to-cart");
				const $inventoryWrap = rp$("#inventory_wrap");
                const $shippingIcon = rp$(".shipping-icon");
                const $inventoryStockIcon = rp$(".badge-instock");
				const $isLeadGenContainer = rp$('#is_lead_gen');
				let $isLeadGen = false;
				if($isLeadGenContainer && $isLeadGenContainer.length > 0){
					const htmlContent = rp$('#is_lead_gen').html();
					if(htmlContent && htmlContent !== 'undefined' && htmlContent.trim() !== ''){
						try {
							$isLeadGen = JSON.parse(htmlContent);
						} catch(e) {
							$isLeadGen = false;
						}
					}
				}
				if($isLeadGen){
					loadMarketplaceViewOffersResources()
				}
				const $zipCallout = rp$('.pdp-zip-callout');
				const savedStoredZipCode = getItem(STORAGE_KEYS.USER_ZIP_CODE);
				const serverZipCode = typeof $zipCallout.attr === 'function'
					? ($zipCallout.attr('data-current-zip') || '')
					: '';
				let serverLocationLabel = typeof $zipCallout.attr === 'function'
					? ($zipCallout.attr('data-current-location-label') || '')
					: '';
				const savedZipCode = serverZipCode || savedStoredZipCode || '';
				if (serverZipCode !== '') {
					// PHP-rendered data is authoritative on fresh load; keep localStorage in sync for cart + modules.
					setItem(STORAGE_KEYS.USER_ZIP_CODE, serverZipCode);
				}
				if (serverLocationLabel === '' && savedZipCode !== '') {
					const cached = getItem(cacheConfig.LOCATION_CACHE_KEY);
					if (cached !== null && typeof cached === 'object') {
						const cachedPostal = String(cached.postalCode ?? '').trim();
						if (cachedPostal === savedZipCode) {
							const fromCache = buildPdpCalloutCityPostalLabel(cached.location);
							if (fromCache !== '') {
								serverLocationLabel = fromCache;
							}
						}
					}
				}
				updatePdpZipCalloutUi(savedZipCode, serverLocationLabel);
				handleZipChangeEvent();
				const $pdpEventDocument = rp$(document);
				if (
					$pdpEventDocument
					&& typeof $pdpEventDocument.off === 'function'
					&& typeof $pdpEventDocument.on === 'function'
				) {
					const locationChangedNamespace = '.productPurchasePdpZipCallout';
					$pdpEventDocument.off(LOCATION_CHANGED_EVENT + locationChangedNamespace);
					$pdpEventDocument.on(LOCATION_CHANGED_EVENT + locationChangedNamespace, (_evt, payload) => {
						const postalCode = String(payload?.postalCode ?? '').trim();
						if (postalCode === '') {
							return;
						}
						// Keep legacy `USER_ZIP_CODE` localStorage in sync so the PDP zip modal
						// pre-fill and cart subtotal don't serve the stale initial-load value.
						setItem(STORAGE_KEYS.USER_ZIP_CODE, postalCode);
						const locationLabel = buildPdpCalloutCityPostalLabel(payload?.location);
						updatePdpZipCalloutUi(postalCode, locationLabel);
					});
				}
				if ($inventoryMessageContentEle && $inventoryMessageContentEle.length > 0 && $addToCartBtn) {
					const eventHandler = HandleInventoryMessageResponse({
						$inventoryMessageContentEle,
						$shippingMessageContentEle,
						$shippingEstimateMessageContentEle,
						$shippingEstimateMessageHelpTextEle,
						$shippingEstimatePostalCodeEle,
						$shippingMessageSectionTitleEle,
						$shippingMessageSectionEle,
						$pickupMessageContentEle,
						$pickupMessageSectionEle,
						$addToCartBtn,
						$inventoryWrap,
                        $shippingIcon,
                        $inventoryStockIcon
					});

					/* Handle inventory message Response
					.*-----------------------------------------*/
					// Due to plugin, all things that depend on document and window are up for causing bugs. Lets clean up before we start
					rp$(document).off(
						"productGetInventoryMessage:response",
						eventHandler
					);
					rp$(document).on("productGetInventoryMessage:response", eventHandler);
				}

				const $dealerSelect = rp$(".offer-dealer-list .dealer-select-button");
				if ($dealerSelect && $dealerSelect.length > 0) {
					$dealerSelect.each(function() {
						rp$(this).on("click", HandleDealerSelect);
					})
				}

				const $viewOffersLink = rp$(".purchase-box .view-offers-link");
				if ($viewOffersLink) {
					$viewOffersLink.on("click", HandleViewMoreDealers);
				}

				const $viewOffersButton = rp$(".view-more-dealer-btn");
				if ($viewOffersButton) {
					$viewOffersButton.on("click", HandleViewMoreDealers);
				}

				const $rpDocument = rp$(document);
				if ($rpDocument && typeof $rpDocument.on === 'function') {
					$rpDocument.on('shown.bs.modal', '.modal', () => {
						resetPurchaseModalStyles(true);
					});
					$rpDocument.on('hidden.bs.modal', '.modal', () => {
						resetPurchaseModalStyles(false);
					});
				}

				// viewOffersLink -> dealerSelectionWarningModal
				const $dealerSelectionWarningModal = rp$(".dealer-selection-warning-modal");
				const $warningModalContinueButton = rp$(".continue-button", $dealerSelectionWarningModal);
				$warningModalContinueButton.on("click", ClearSelectedDealer);

				// adding paypal payment message

				let sale_price = '';
				try {
					sale_price = rp$('.product-purchase-module').data('sale-price');
				} catch (e) {/* do nothing if sale price is empty or not having value */}

				const paymentsMessageContainerClass = '.pp-message';
				const paymentsMessageData = {
					elemOrSelector: paymentsMessageContainerClass,
					amount: sale_price,
					placement: 'product',
				}
				paypalSmartButtons.initPaypalMessage(paymentsMessageData);
			}
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}

export default THE_SCRIPT;
